<template>
   <v-data-table
      :headers="headers"
      :items="items"
      sort-by.sync="name"
      :search="search"
      :custom-filter="customSearch"
      class="elevation-0 general-table"
      :loading="isLoading"
      @click:row="openDetailPage"
      :loading-text="$t('GLOBAL-LOADING-PLEASE_WAIT')"
    >
      <template v-slot:header.name="{ header }">
        <lang t="ATTRIBUTES-TBL-HEADER-NAME"></lang>
      </template>

      <template v-slot:header.syncWithKiSoft="{ header }">
        <lang t="ATTRIBUTES-TBL-HEADER-SYNC_WITH_KISOFT"></lang>
      </template>

      <template v-slot:header.type="{ header }">
        <lang t="ATTRIBUTES-TBL-HEADER-DATA_TYPE"></lang>
      </template>

      <template v-slot:header.isHostAttribute="{ header }">
        <lang t="ATTRIBUTES-TBL-HEADER-HOST"></lang>
      </template>

      <template v-slot:header.calculationrule="{ header }">
        <lang t="ATTRIBUTES-TBL-HEADER-CALCULATION_RULE"></lang>
      </template>

      <template v-slot:header.isWritable="{ header }">
        <lang t="ATTRIBUTES-TBL-HEADER-WRITEABLE"></lang>
      </template>
      <template v-slot:header.isActive="{ header }">
        <lang t="ATTRIBUTES-TBL-HEADER-IS-ACTIVE"></lang>
      </template>
      <template v-slot:header.isMandatory="{ header }">
        <lang t="ATTRIBUTES-TBL-HEADER-IS-MANDATORY"></lang>
      </template>

      <template v-slot:header.tags="{ header }">
        <lang t="ATTRIBUTES-TBL-HEADER-TAGS"></lang>
      </template>

      <template v-slot:header.owner="{ header }">
        <lang t="ATTRIBUTES-TBL-HEADER-OWNER"></lang>
      </template>
      

      <template v-slot:top>
        <div class="d-flex align-center flex-wrap py-2 mb-3">
          <v-text-field
            clearable
            v-model="search"
            class="general-table__search"
            prepend-inner-icon="mdi-magnify"
            :label="$t('GLOBAL-DO_SEARCH')"
            solo
            flat
            dense
            hide-details
          ></v-text-field>

          <v-spacer></v-spacer>

          <Button type="outside-label" icon="mdi-plus" :label="addNewAttributeLabel" @click="addAttribute" />

        </div>
      </template>

      <template v-slot:item.name="{item}">
        <span>{{ attributeName(item) }}</span>
      </template>
      <template v-slot:item.syncWithKiSoft="{ item }">
        <template v-if="item.syncWithKiSoft == 1"
          ><lang t="GLOBAL-YES"></lang
        ></template>
        <template v-else><lang t="GLOBAL-NO"></lang></template>
      </template>

      <template v-slot:item.calculationrule="{ item }">
        <template v-if="item.calculationrule && item.calculationrule.name">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span style="cursor:pointer;" v-bind="attrs" v-on="on"
                ><lang t="GLOBAL-YES"></lang
              ></span>
            </template>
            <span>{{ item.calculationrule.name }}</span>
          </v-tooltip>
        </template>

        <template v-else><lang t="GLOBAL-NO"></lang></template>
      </template>

      <template v-slot:item.isHostAttribute="{ item }">
        <template v-if="item.isHostAttribute == 1"
          ><lang t="GLOBAL-YES"></lang
        ></template>
        <template v-else><lang t="GLOBAL-NO"></lang></template>
      </template>

      <template v-slot:item.isWritable="{ item }">
        <template v-if="item.isWritable == 1"
          ><lang t="GLOBAL-YES"></lang
        ></template>
        <template v-else><lang t="GLOBAL-NO"></lang></template>
      </template>

      <template v-slot:item.tags="{ item }">
        <div class="attribute-tags">
        <SimpleChip v-if="item.isCustom == 1" auto-width :value="item.isCustom" :name="$t('ATTRIBUTE_IS_CUSTOM')" small default-icon="" readonly></SimpleChip>
        <SimpleChip v-if="item.isValueChain == 1" auto-width :value="item.isValueChain" :name="$t('ATTRIBUTE-LABEL-IS_VALUE_CHAIN')" small default-icon="" readonly></SimpleChip>
      </div>
      </template>

      <template v-slot:item.isMandatory="{ item }">
        <template v-if="item.isMandatory == 1"
          ><lang t="GLOBAL-YES"></lang
        ></template>
        <template v-else><lang t="GLOBAL-NO"></lang></template>
      </template>


      <template v-slot:item.owner="{ item }">
        <span>{{ ownerLabel(item.owner) }}</span>
      </template>

      <template v-slot:item.isActive="{ item }">
        <template v-if="item.isActive == 1"
          ><lang t="GLOBAL-YES"></lang
        ></template>
        <template v-else><lang t="GLOBAL-NO"></lang></template>
      </template>

      <template v-slot:item.actions="{ item }">
     
        <v-icon
          small
          class="pa-1"
          color="grey darken-2"
          @click.stop.prevent="deleteItem(item)"
          >mdi-trash-can-outline</v-icon
        >
      </template>

      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize"
          ><lang t="Reset"></lang
        ></v-btn>
      </template>
    </v-data-table>
</template>

<script>

import Button from '../../../components/ui-elements/Button.vue';
import DisplayNumber from '../../../components/DisplayNumber.vue';
import SimpleChip from '../../../components/ui-elements/SimpleChip.vue';
  export default {
    name: 'AttributeList',
    components:{
    Button,
    DisplayNumber,
    SimpleChip
  },
  props:{
    items: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: true
    },
    isBundleAttribute:{
      type: Boolean,
      default: true
    }
  }, 
    data: () => ({

    search: "",
    headers: [],
    isBoundleAttribute: undefined,
    calculationRules: [],
    
  }),
  computed: {
    units() {
      return ["mm", "g"];
    },
    types() {
      return ["number", "enum", "string", "boolean", "image"];
    },
    owners(){
        return [
          {value: 'HOST', label: this.$i18n.t('ATTRIBUTE-OWNER-HOST')},
          {value: 'BG', label: this.$i18n.t('ATTRIBUTE-OWNER-BG')},
          {value: 'SITE', label: this.$i18n.t('ATTRIBUTE-OWNER-SITE')},
        ]
      },
      addNewAttributeLabel(){
        if(this.isBundleAttribute) return this.$i18n.t('ATTRIBUTES-NEW_BUNDLE_ATTRIBUTE');
        return this.$i18n.t('ATTRIBUTES-NEW_ITEM_ATTRIBUTE');
      },
    currentLangShortCode() {
      return this.$store.getters.langShortcode;
    }
  },
  watch:{
    isBundleAttribute: {
      handler(){
        this.setHeaders();
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    attributeName(attribute){
      let name = '';
      if(attribute.displayName && attribute.displayName[this.currentLangShortCode]){
        name = attribute.displayName[this.currentLangShortCode]+' ';
      }
      let attributePropertyName = attribute.name;
      if(attributePropertyName.includes('custom__')){
        attributePropertyName = attributePropertyName.replace('custom__', '');
      }
      if(attribute.valueChainName && attribute.valueChainName.length > 0 && attribute.isValueChain){
        attributePropertyName = attribute.valueChainName;
      }
      name += `(${attributePropertyName})`;
      
      return name;
    },

    ownerLabel(owner){
        const findOwner = this.owners.find((el) => el.value === owner);
        if(!findOwner) return "";
        return findOwner.label;
    },

    addAttribute(){
      this.$emit('addAttribute', this.isBundleAttribute);
    },
    
    openDetailPage(item){
      this.$router.push({name: 'settings-attributes-item', params: {id: item.id}});
    },
    deleteItem(item) {
      this.$emit('deleteItem', item);
    },

    setHeaders(){
      
      if(this.isBundleAttribute){
        this.headers = [
                { text: "Name", align: "start", value: "name", sortable: true, class: 'general-table__th--7' },
                { text: "type", value: "type", sortable: true, class: 'general-table__th--7' },
                { text: "calculationRule", value: "calculationrule", sortable: true, class: 'general-table__th--7' },
                { text: "isWriteable", value: "isWritable", sortable: true, class: 'general-table__th--7' },
                { text: "tags", value: "tags", align: "center", sortable: true, class: 'general-table__th--7' },
                { text: "isMandatory", value: "isMandatory", sortable: true, class: 'general-table__th--7' },
                { text: "owner", value: "owner", sortable: true, class: 'general-table__th--7' },
                { text: "", value: "actions", sortable: false, width: "80px" },
              ];
      }else{
        this.headers = [
              { text: "Name", align: "start", value: "name", sortable: true, class: 'general-table__th--8' },
              { text: "type", value: "type", sortable: true, class: 'general-table__th--8' },
              { text: "calculationRule", value: "calculationrule", sortable: true, class: 'general-table__th--8' },
              { text: "isWriteable", value: "isWritable", sortable: true, class: 'general-table__th--8' },
              { text: "tags", value: "tags", sortable: true, align: "center", class: 'general-table__th--8' },
              { text: "isMandatory", value: "isMandatory", sortable: true, class: 'general-table__th--8' },
              { text: "owner", value: "owner", sortable: true, class: 'general-table__th--8' },
              { text: "isActive", value: "isActive", sortable: true, class: 'general-table__th--8' },

              { text: "", value: "actions", sortable: false, width: "80px" },
            ];
      }
    },

    customSearch(value, query, item){
      if(!item.displayName || !Object.values(item.displayName).length){
        return value !== null && query !== null && typeof value === 'string' && value.toString().toLocaleLowerCase().includes(query.toLocaleLowerCase());
      }
      if(item.valueChainName && item.valueChainName.length > 0 && item.isValueChain){
        const foundValueChainName = item.valueChainName.toLocaleLowerCase().includes(query.toLocaleLowerCase());
        if(foundValueChainName) return true; 
      }

        return Object.values(item.displayName).some((label) => label.toLocaleLowerCase().includes(query.toLocaleLowerCase())) 
        || ( value !== null && query !== null && typeof value === 'string' && value.toString().toLocaleLowerCase().includes(query.toLocaleLowerCase()));
    }

  },
  }
</script>

<style lang="scss" scoped>
  .general-table{
    background-color: transparent!important;
  }

  .attribute-tags{
    display: flex; 
    flex-wrap: wrap; 
    justify-content: flex-start; 
    align-items: center; 
    margin: .4em;
    width: 210px;
    & > *{
      margin: .2em;
    }
  }
</style>
